import { Alert, AlertIcon, HStack } from "@chakra-ui/react";
import { Heading, Paper, Text } from "@equidefi/ui";

export const InvestmentRejected = () => {
  return (
    <Paper mt="4">
      <Alert
        status="error"
        w="full"
        p="4"
        borderRadius="8px"
        border="2px solid"
        borderColor="equidefi.red"
        flexDirection="column"
        alignItems="flex-start">
        <HStack mb="2.5">
          <AlertIcon ml="0" />
          <Heading m="0" fontWeight="bold">
            Canceled
          </Heading>
        </HStack>

        <Text textStyle="body2" m={0}>
          The investment has been canceled by the issuer.
        </Text>
      </Alert>
    </Paper>
  );
};
